/**
 * To use, first attach an object that implements onIntersect using viewPort.attach(yourObject);
 * then wait for the viewPort to intersect.
 * */
export class ViewPort {
    constructor() {
        this.intersectionThreshold = 0.3;
        this.observers = [];
        let self = this;
        // Default behavior is to immediately fire the cb!
        //https://stackoverflow.com/questions/53214116/intersectionobserver-callback-firing-immediately-on-page-load
        // To test, create a mock of IntersectionObserver.
        //https://stackoverflow.com/questions/44249985/js-testing-code-that-uses-an-intersectionobserver
        this.intersectionObserver = new IntersectionObserver(self.onIntersect.bind(self), {
            root: null,
            rootMargin: '0px',
            threshold: this.intersectionThreshold
        });
    }
    onIntersect(e, obs) {
        let intersects = e.filter(entry => entry.intersectionRatio > this.intersectionThreshold);
        // O(n**2) but there are only around 6 elements
        intersects.forEach(entry => {
            this.observers.forEach(observer => {
                if (observer.idMatches(entry.target.id)) {
                    observer.onIntersect();
                }
            });
        });
    }
    attach(observer) {
        this.intersectionObserver.observe(observer.htmlElement);
        this.observers.push(observer);
    }
}
